import React from 'react';
import { useTranslation } from 'react-i18next';

import { SubHeader, SubHeadingRight, SubHeadingLeft } from './WelcomeChecklist.styles';

export function WelcomeChecklistHeader() {
  const { t } = useTranslation();

  return (
    <SubHeader>
      <SubHeadingLeft>{t('welcomeChecklist.checklistSubTitle')}</SubHeadingLeft>
      <SubHeadingRight>
        <span>{t('welcomeChecklist.yes')}</span>
        <span>{t('welcomeChecklist.no')}</span>
      </SubHeadingRight>
    </SubHeader>
  );
}

export default WelcomeChecklistHeader;
